import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateReturnCustomerContactContactType = [
  "giftReturner",
  "buyer",
  "both",
] as const;

export const updateReturnCustomerContact = {
  name: "updateReturnCustomerContact" as const,
  input: z.object({
    returnId: zExt.objectId(),
    contactType: z.enum(updateReturnCustomerContactContactType),
    email: z.email().nullish(),
    phone: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
